import { render } from "./ProductSeoComponent.vue?vue&type=template&id=1d1edefd"
import script from "./ProductSeoComponent.vue?vue&type=script&lang=js"
export * from "./ProductSeoComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/seo/ProductSeoComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d1edefd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d1edefd', __exports__)) {
    api.reload('1d1edefd', __exports__)
  }
  
  module.hot.accept("./ProductSeoComponent.vue?vue&type=template&id=1d1edefd", () => {
    api.rerender('1d1edefd', render)
  })

}


export default __exports__